import { Host, h } from '@stencil/core';
export class AibaAlertWithIndex {
  constructor() {
    this.styles = undefined;
    this.variant = undefined;
    this.customVariant = undefined;
    this.renderWithoutData = false;
    this.index = undefined;
    this.indexHeading = undefined;
    this.indexContent = undefined;
    this.handlers = undefined;
    this.reRender = undefined;
  }
  handler(event) {
    let data = event['detail']['data'];
    if (data) {
      let { index, indexHeading, indexContent, variant } = data;
      this.index = index;
      this.indexHeading = indexHeading;
      this.indexContent = indexContent;
      this.variant = variant;
    }
  }
  async componentWillLoad() {
    if (this.handlers && this.handlers.handleAlertIndexWillLoad) {
      const response = await this.handlers.handleAlertIndexWillLoad();
      this.index = response.index;
      this.indexHeading = response.indexHeading;
      this.indexContent = response.indexContent;
      this.variant = response.variant;
    }
  }
  render() {
    return (h(Host, null, h("div", { class: `aiba-alert-with-index ${this.variant}` }, h("div", { class: 'left-index' }, h("div", { class: 'index-button' }, h("aiba-label", { tag: "span", "aria-label": this.indexHeading, text: this.indexHeading ? this.indexHeading : '', _id: 'left-heading' }), h("aiba-label", { tag: "span", "aria-label": this.index, text: this.index ? this.index : '0', _id: 'left-heading-index' }))), h("div", { class: 'right-desc' }, h("aiba-label", { tag: "span", "aria-label": this.indexContent, text: this.indexContent ? this.indexContent : '', _id: 'right-heading' })))));
  }
  static get is() { return "aiba-alert-with-index"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-alert-with-index.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-alert-with-index.css"]
    };
  }
  static get properties() {
    return {
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "variant": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'low' | 'moderate' | 'high' | 'extreme' | 'very-high'",
          "resolved": "\"extreme\" | \"high\" | \"low\" | \"moderate\" | \"very-high\"",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "variant",
        "reflect": false
      },
      "customVariant": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "custom-variant",
        "reflect": false
      },
      "renderWithoutData": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "render-without-data",
        "reflect": false,
        "defaultValue": "false"
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "index": {},
      "indexHeading": {},
      "indexContent": {},
      "reRender": {}
    };
  }
  static get listeners() {
    return [{
        "name": "update-alert-data",
        "method": "handler",
        "target": "window",
        "capture": false,
        "passive": false
      }];
  }
}
//# sourceMappingURL=aiba-alert-with-index.js.map
